import React from "react";

import * as SC from "./PrintCard.styled";
import CardHeader from "./PrintCardHeader/PrintCardHeader";

const PrintCard = ({ title, fullWidth, children, styling, showWinner }) => {
  return (
    <SC.CardWrapper fullWidth={fullWidth} styling={styling}>
      <CardHeader title={title} showWinner={showWinner} />
      <SC.Divider />
      <SC.Children>{children}</SC.Children>
    </SC.CardWrapper>
  );
};
export default PrintCard;
